import { ISmartProps } from './types';
import { View } from './view';

export type ProgressBarProps = Omit<ISmartProps, 'css'>;

export const ProgressBar = View;
